import React from 'react';
//import setState from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import './css/Navbar.css';

//import Overlay from './Overlay';

export default class navbar extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
            show: true,
            scrollPos: 0,
            search:'null',
            filterState: false
        };
    }

    onTrigger = (e) => {
        e.preventDefault();
        this.setState.search = e.target.search.value;
        this.props.childToParent(this.search);
        this.props.childToParent("");
    }

    onFilterClick = (e) => {
        e.preventDefault();
        if(this.filterState === false)
            this.filterState = true;
        else
            this.filterState = false;
        
            this.props.childToParentFilterState(this.filterState);
    }

    componentDidMount() {
        window.addEventListener("scroll", this.handleScroll);
    }
    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
    }
    handleScroll = () => {
            // console.log(document.body.getBoundingClientRect());
        this.setState({
            scrollPos: document.body.getBoundingClientRect().top,
            show: document.body.getBoundingClientRect().top > this.state.scrollPos
        });
    };

    render() {
        const data = "cool";
        return (
                <nav title ={this.state.show ? "active" : "hidden"} className="navbar navbar-expand-lg navbar-light bg-light">
                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo03" aria-controls="navbarTogglerDemo03" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                    </button>
                    <a className="navbar-brand" href="">PawsNearMe</a>
                    <div className="collapse navbar-collapse" id="navbarTogglerDemo03">
                        <ul className="navbar-nav mr-auto mt-2 mt-lg-0">
                            <li className="nav-item active">
                            </li>
                            <li className="nav-item">
                            </li>
                        </ul>
                        
                        <input className = "filter" name = "filter" type="image" src="https://cdn-icons-png.flaticon.com/512/107/107799.png" alt='Filter' onClick={this.onFilterClick}/>
                        <div>
                            {/*
                            <form id = "form1" className="form-inline my-2 my-lg-0" onSubmit = {this.onTrigger}>
                                <input className="form-control mr-sm-2" name = "search" type="text" placeholder="Search" aria-label="Search"></input>
                                <button type="Submit" form="form1" className="btn btn-outline-success" >Search</button> 
                            </form>
                            */}
                        </div>  
                    </div>
                </nav>         
        );
    }
}
{/*
*/}
                           
